/* eslint-disable import/no-import-module-exports */
import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from "./reducer";
export var store = configureStore({
  reducer: rootReducer,
  devTools: {
    name: '@BEEP/TOP_UP_BALANCE',
    trace: process.env.NODE_ENV === 'development'
  }
});
export var initializeModuleStore = function initializeModuleStore() {
  // @ts-expect-error module hot typing
  if (process.env.NODE_ENV === 'development' && module.hot) {
    // @ts-expect-error module hot typing
    module.hot.accept('./reducer', function () {
      return store.replaceReducer(rootReducer);
    });
  }
  return store;
};